export abstract class TableConstants {
  public static get pageSize() {
    return [10, 25, 50, 100, 250, 500];
  }

  public static get dialogPageSize() {
    return [50, 100, 150];
  }
}
